import React from 'react';

import SidebarMenuItem from './SidebarMenuItem';

const SidebarMenuCompany = () => {
  return <SidebarMenuItem to={'/proposals'} label={'Proposals'} />;
};

export default SidebarMenuCompany;
